import React from 'react';

const Title = () => <h1>Order Review</h1>;

export default Title;
